module.exports = __webpack_public_path__ + "img/photo01.1264b9c8.jpg";